import { marketProducts, nonAnonymousMarketProducts } from "constants/market";
import { TCreateDetail } from "types/management";
import { TMarketProductData, TMarketResponseDetail } from "types/market";

/** 임시저장 데이터를 불러올 때 상품을 판단하는 함수입니다. */
export const getTempDataProduct = (
  request?: TMarketResponseDetail,
  companyData?: TCreateDetail
): TMarketProductData => {
  if (!request || !companyData) return marketProducts[0];
  // 실명 데이터 거래 선택 시
  if (request.contentObject.privacyPolicy?.identifier === 1 && companyData?.nonAnonymousTf === true) {
    const targetProduct = nonAnonymousMarketProducts?.find(
      ({ title }) => title === "마이디 - 올데이터 프리미엄(실명거래용)"
    );
    return targetProduct || marketProducts[0];
  }
  return marketProducts[0]; // "마이디 - 올데이터 프리미엄"
};
